module.exports = __webpack_public_path__ + "img/f5.9078f494.jpg";